import { IResult } from '../types/IResponse';
import { IViewDetail } from '../types/IView';
import { Request } from './Request';

export interface IGetViewByPathParams {
  path: string;
}

// The ViewDetail should be a property of the result, not the type of the result object itself.
export interface IGetViewByPathResult extends IResult, IViewDetail {
}

export class GetViewByPathRequest extends Request<IGetViewByPathParams, IGetViewByPathResult> {
  constructor(path: string) {
    super('getViewByPath', { path: path });
  }
}
